// resources/js/woocommerce/account/nav-toggle.js

/**
 * Off-canvas navigatie voor Mijn Account
 * - "over" (default) opent boven header en onder admin-bar (CSS gebruikt --wp-adminbar-h)
 * - "under" (optioneel) via data-acc-nav-mode="under" → JS zet top op headerhoogte
 * - scroll lock zonder layout shift
 * - zet dynamisch --wp-adminbar-h op <html> (werkelijke hoogte #wpadminbar)
 */

export function mount() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
    return;
  }

  const root =
    document.querySelector('.wk-account') ||
    document.querySelector('.woocommerce-account');
  if (!root) return;
  if (root.dataset.accNavMounted === '1') return;

  const btn     = root.querySelector('[data-acc-nav-toggle]');
  const nav     = root.querySelector('[data-acc-nav]');
  const overlay = root.querySelector('[data-acc-nav-overlay]');
  if (!btn || !nav || !overlay) return;

  const html   = document.documentElement;
  const body   = document.body;
  const mode   = (root.dataset.accNavMode || 'over').toLowerCase();
  const headerEl =
    document.querySelector('.wk-header.sticky') ||
    document.querySelector('.wk-header');

  // --- Adminbar hoogte → CSS var zetten (betrouwbaarder dan 32/46px) ---
  const setAdminbarVar = () => {
    const ab = document.getElementById('wpadminbar');
    const h  = ab ? Math.round(ab.getBoundingClientRect().height) : 0;
    html.style.setProperty('--wp-adminbar-h', h + 'px');
  };
  setAdminbarVar();
  // opnieuw meten bij resize/orientation
  window.addEventListener('resize', setAdminbarVar, { passive: true });

  const getScrollbarWidth = () => Math.max(0, window.innerWidth - html.clientWidth);
  const isOpen = () => root.classList.contains('nav-open');

  const applyPositionForMode = () => {
    if (mode === 'under' && headerEl) {
      const h = Math.round(headerEl.getBoundingClientRect().height);
      nav.style.top = h + 'px';
      overlay.style.top = h + 'px';
    } else {
      // "over": laat CSS (account-mobile.css) adminbar/safe-area afhandelen
      nav.style.top = '';
      overlay.style.top = '';
    }
  };

  const open = () => {
    if (isOpen()) return;
    const sw = getScrollbarWidth();
    html.classList.add('lock-scroll');
    body.style.paddingRight = sw ? sw + 'px' : '';
    applyPositionForMode();
    root.classList.add('nav-open');
    btn.setAttribute('aria-expanded', 'true');
    overlay.hidden = false;
  };

  const close = () => {
    if (!isOpen()) return;
    root.classList.remove('nav-open');
    btn.setAttribute('aria-expanded', 'false');
    overlay.hidden = true;
    html.classList.remove('lock-scroll');
    body.style.paddingRight = '';
  };

  const toggle = () => (isOpen() ? close() : open());

  btn.addEventListener('click', toggle);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Sluit bij desktopbreedte
  const mql = window.matchMedia('(min-width: 1024px)');
  const onChange = (e) => { if (e.matches) close(); };
  if (mql.addEventListener) mql.addEventListener('change', onChange);
  else if (mql.addListener) mql.addListener(onChange);

  // Als open en headerhoogte wijzigt → position opnieuw toepassen
  window.addEventListener('resize', () => { if (isOpen()) applyPositionForMode(); }, { passive: true });

  root.dataset.accNavMounted = '1';
}

export default mount;
